import { ChangeDetectionStrategy, Component } from '@angular/core';
import { KpiFormComponent } from '../../shared/components/kpi-form/kpi-form.component';

@Component({
  standalone: true,
  selector: 'app-budget-page',
  templateUrl: './budget-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [KpiFormComponent],
})
export class BudgetPageComponent {}
